export default __webpack_public_path__ + "static/media/EE.ec3c6c0f.svg";